export default {
  jsonrpc: '2.0',
};
